import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import Iconify from "../iconify/Iconify";

function OrderCancelConfirmDialog({ open, onClose, onConfirm, loading }) {
  const [reason, setReason] = useState("");
  const [customReason, setCustomReason] = useState("");

  const reasons = [
    "Customer requested cancellation",
    "Order placed by mistake",
    "Duplicate order created",
    "Items unavailable / out of stock",
    "Kitchen unable to prepare order",
    "Payment issue",
    "Staff error",
    "Other",
  ];

  // Reset state when dialog closes
  useEffect(() => {
    if (!open) {
      setReason("");
      setCustomReason("");
    }
  }, [open]);

  const handleConfirm = () => {
    const finalReason = reason === "Other" ? customReason.trim() : reason;

    onConfirm({
      type: reason,
      message: finalReason,
    });
  };

  const isConfirmDisabled =
    !reason || (reason === "Other" && !customReason.trim());

  return (
    <Dialog
      open={open}
      maxWidth="xs"
      fullWidth
      onClose={(event, dialogReason) => {
        if (dialogReason !== "backdropClick") {
          onClose();
        }
      }}
    >
      {/* Header */}
      <DialogTitle sx={{ pb: 1 }}>
        <Box display="flex" alignItems="center" gap={1}>
          <Iconify icon="mdi:alert-circle-outline" width={22} color="#d32f2f" />
          <Typography variant="h6" fontWeight={600}>
            Cancel Order
          </Typography>
        </Box>
      </DialogTitle>

      {/* Content */}
      <DialogContent>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Please select a reason for cancelling this order.
          <br />
          <strong>This action cannot be undone.</strong>
        </Typography>

        {/* Reason dropdown */}
        <TextField
          select
          fullWidth
          label="Cancel Reason"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          margin="normal"
        >
          {reasons.map((r) => (
            <MenuItem key={r} value={r}>
              {r}
            </MenuItem>
          ))}
        </TextField>

        {/* Custom reason */}
        {reason === "Other" && (
          <TextField
            fullWidth
            autoFocus
            label="Enter custom reason"
            value={customReason}
            onChange={(e) => setCustomReason(e.target.value)}
            margin="normal"
          />
        )}
      </DialogContent>

      {/* Actions */}
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={onClose} variant="outlined" disabled={loading}>
          Back
        </Button>

        <Button
          onClick={handleConfirm}
          variant="contained"
          color="error"
          disabled={isConfirmDisabled || loading}
          startIcon={<Iconify icon="mdi:close-circle-outline" />}
        >
          {loading ? "Cancelling..." : "Cancel Order"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default OrderCancelConfirmDialog;
